import i from "./index.ce.vue.js";
import { defineAndRegisterElement as e } from "../../utils/register-element.js";
const r = e(i);
export {
  r as initAiPutCaseDialog
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/ai-put_case-dialog/index.js
// module id = 1164
// module chunks = 41